import React from 'react';
import { Page } from '../Page';
export function Page11() {
  return <Page pageNumber={33} variant="light" data-id="element-543">
      <div className="flex flex-col h-full" data-id="element-544">
        <div className="mb-6 pt-2" data-id="element-545">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-546">
            Looking Ahead
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-547">
            When Calories{' '}
            <span className="text-tealslate" data-id="element-548">Start to Matter</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-549" />
        </div>

        <div className="mb-6 flex flex-col items-center justify-center py-4 border-y border-[#D8D8D0]" data-id="element-550">
          <div className="text-[72px] font-serif text-[#1F1F1F] leading-none tracking-tight mb-1" data-id="element-551">
            5-15<span className="text-tealslate" data-id="element-552">%</span>
          </div>
          <p className="text-sm font-bold text-tealslate uppercase tracking-[0.2em]" data-id="element-553">
            The Sustainable Deficit
          </p>
        </div>

        <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-6 max-w-2xl mx-auto text-center" data-id="element-554">
          For the first few months on GLP-1 medication, you likely won't need to
          count calories. The medication suppresses your appetite enough that
          focusing on protein, fiber, and hydration naturally creates a caloric
          deficit. But eventually, that may change.
        </p>

        <div className="grid grid-cols-3 gap-5 mb-6" data-id="element-555">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-556">
            <div className="text-tealslate font-serif text-2xl mb-1" data-id="element-557">01</div>
            <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-558">
              Hitting a Plateau
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-559">
              As you lose weight, your body requires fewer calories to maintain
              its new, smaller size.
            </p>
          </div>
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-560">
            <div className="text-tealslate font-serif text-2xl mb-1" data-id="element-561">02</div>
            <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-562">
              Medication Adaptation
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-563">
              Over time, your body adapts to the medication. Hunger cues will
              return.
            </p>
          </div>
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-564">
            <div className="text-tealslate font-serif text-2xl mb-1" data-id="element-565">03</div>
            <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-566">
              Transitioning Off
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-567">
              If you stop the medication, you must understand your baseline to
              prevent regain.
            </p>
          </div>
        </div>

        <div className="flex-1 flex flex-col" data-id="element-568">
          <h2 className="text-xl font-serif text-[#1F1F1F] mb-3 text-center" data-id="element-569">
            How to Find Your Maintenance
          </h2>
          <div className="grid grid-cols-2 gap-5 mb-4" data-id="element-570">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-571">
              <h3 className="font-bold text-[#1F1F1F] text-xs mb-2" data-id="element-572">
                Method 1: The Quick Math
              </h3>
              <p className="text-[11px] text-[#7A7A70] mb-2 leading-[1.6]" data-id="element-573">
                Multiply your bodyweight (in lbs) by 14-18 depending on activity
                level.
              </p>
              <div className="bg-[#D8D8D0] p-2 text-center font-mono text-[10px] text-[#3B3B3B] leading-relaxed" data-id="element-574">
                BW × 14 (Sedentary)
                <br data-id="element-575" />
                BW × 16 (Moderate)
                <br data-id="element-576" />
                BW × 18 (Active)
              </div>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-577">
              <h3 className="font-bold text-[#1F1F1F] text-xs mb-2" data-id="element-578">
                Method 2: Guess & Check
              </h3>
              <p className="text-[11px] text-[#7A7A70] leading-[1.6]" data-id="element-579">
                Track your daily calories and morning weight for 2 weeks. If
                your average weight stays the same, your average calorie intake
                is your maintenance.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-auto bg-tealslate text-white p-3 text-center font-bold text-sm" data-id="element-580">
          If maintenance is 2,000 calories, a sustainable 5-15% deficit =
          1,700-1,900 calories/day
        </div>
      </div>
    </Page>;
}